import { useState } from 'react';

import arrowDown from './arrow-down.svg';
import arrowUp from './arrow-up.svg';
import rukaLogo from './ruka-logo.png';
import pyhaLogo from './pyha-logo.svg';
import { Transaction } from '../../../types/customer';

interface Props {
  transaction: Transaction;
  title: string | JSX.Element;
  titleElement: JSX.Element;
  children: JSX.Element;
}

function OrderItemDropdown(props: Props): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className='border-gray-300 border-1 rounded-md bg-white p-3 my-4'>
      <div
        className='accordionTop flex my-auto cursor-pointer relative'
        onClick={() => setIsOpen(!isOpen)}
      >
        <img
          src={
            props.transaction.resort.toLowerCase() === 'ruka'
              ? rukaLogo
              : pyhaLogo
          }
          alt='Ruka'
          className='w-14'
        />

        <div className='mx-3 font-[500] capitalize'>{props.title}</div>

        <img
          src={isOpen ? arrowUp : arrowDown}
          alt={isOpen ? 'Close' : 'Open'}
          className='ml-auto mb-3 w-4 absolute right-1 top-2'
        />
      </div>

      {props.titleElement}

      <div
        className={`overflow-hidden transition-[max-height] duration-500 ease-in-out delay-0 ${
          !isOpen ? 'max-h-0' : ''
        }`}
      >
        {props.children}
      </div>
    </div>
  );
}

export default OrderItemDropdown;
